import Select from "react-select"
import React, { Fragment } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  Form,
  CardTitle,
  Label,
} from "reactstrap"
export const FiltersCard = props => {
  const {
    item,
    setItem,
    options,
    filterLabel,
    fromDate = "",
    toDate = "",
    setFromDate = () => {},
    setToDate = () => {},
    showToDate = true,
    setFiltersData = () => {},
    showType,
    setType,
    optionsType,
    type
  } = props

  const handleSubmit = e => {
    e.preventDefault()
    setFiltersData({
      item: item,
      fromDate: fromDate,
      toDate: toDate,
    })
  }
  return (
    <Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4"></CardTitle>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Row>
                  <Col lg={`${showToDate ? 3 : 6}`}>
                    <div className="row mb-4">
                      <Col sm={9} md={2} lg={2}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-sm-3 col-form-label text-nowrap"
                        >
                          From
                        </Label>
                      </Col>
                      <Col sm={3} md={6} lg={10}>
                        <Input
                          type="date"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          onChange={e => {
                            setFromDate(e.target.value)
                          }}
                          value={fromDate}
                        />
                      </Col>
                    </div>
                  </Col>
                  {showToDate && (
                    <Col lg={3}>
                      <div className="row mb-4">
                        <Col sm={9} md={2} lg={2}>
                          <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-3 col-form-label text-nowrap"
                          >
                            To
                          </Label>
                        </Col>
                        <Col sm={9} md={6} lg={10}>
                          <Input
                            type="date"
                            className="form-control"
                            id="horizontal-email-Input"
                            onChange={e => {
                              setToDate(e.target.value)
                            }}
                            value={toDate}
                          />
                        </Col>
                      </div>
                    </Col>
                  )}
                  {showType && (
                    <Col lg={3}>
                      <div className="row mb-4">
                        <Col sm={9} md={2} lg={2}>
                          <Label
                              htmlFor="horizontal-email-Input"
                              className="col-sm-3 col-form-label text-nowrap"
                          >
                            {[undefined, null, ""].includes(filterLabel)
                                ? "Type"
                                : filterLabel}
                          </Label>
                        </Col>
                        <Col sm={9} md={6} lg={10}>
                          <Select
                              options={optionsType}
                              maxMenuHeight={150}
                              classNamePrefix="select2-selection"
                              onChange={type => {
                                setType(type.label)
                              }}
                              value={{ label: type, value: type }}
                          />
                        </Col>
                      </div>
                    </Col>
                  )}
                  {!props.notDisplayFilter ?
                  <Col lg={4}>
                    <div className="row mb-4">
                      <Col sm={3} md={3} lg={3}>
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label text-nowrap"
                        >
                          {[undefined, null, ""].includes(filterLabel)
                            ? "Type"
                            : filterLabel}
                        </Label>
                      </Col>
                      <Col sm={9} md={9} lg={9}>
                        <Select
                          options={options}
                          maxMenuHeight={150}
                          classNamePrefix="select2-selection"
                          onChange={item => {
                            setItem(item.label)
                          }}
                          value={{ label: item, value: item }}
                        />
                      </Col>
                    </div>
                  </Col>
                      : ''
                  }
                  <Col lg={2}>
                    <div className="row mb-4">
                      <Col sm={9} md={2} lg={2}></Col>
                      <Col sm={9} md={6} lg={10}>
                        <div>
                          <Button
                            type="button"
                            color="primary"
                            className="w-md"
                            onClick={() => {
                              props.call()
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  )
}
